import { useContext } from 'react';
import { ApiErrorContext } from './ApiProvider';
import ErrorPage from '../components/ErrorPage';

const ApiErrorOrRender = ({ children }) => {
    const { apiError } = useContext(ApiErrorContext);

    if (apiError) {
        return <ErrorPage errorKey="sbkApiCommunicationError" />;
    }

    return children;
};

export default ApiErrorOrRender;
